import { render, staticRenderFns } from "./InvoiceUi.vue?vue&type=template&id=705b4f11&scoped=true"
import script from "./InvoiceUi.vue?vue&type=script&lang=js"
export * from "./InvoiceUi.vue?vue&type=script&lang=js"
import style0 from "./InvoiceUi.vue?vue&type=style&index=0&id=705b4f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b4f11",
  null
  
)

export default component.exports